import {
	AngularRoutesEnum,
	AppRoutesEnum,
	DojoRoutesEnum,
	NavigationBase,
	VersionRouteEnum,
} from "@core/layout/enums/layout-routes.enum";

type RoutePathParam = `:${string}`;

type RoutesByBase<Base extends NavigationBase> = Base extends NavigationBase.DOJO
	? (DojoRoutesEnum | RoutePathParam) | (DojoRoutesEnum | RoutePathParam)[]
	: (AngularRoutesEnum | RoutePathParam) | (AngularRoutesEnum | RoutePathParam)[];

export class LinkUtils {
	static generateLinkModel<Base extends NavigationBase>(
		base: Base,
		routes: RoutesByBase<Base>,
		queryParams: Record<string, string> = {},
	): string {
		const routesArray = Array.isArray(routes) ? routes : [routes];
		const paths: string[] = [];
		const fragments: string[] = [];

		if (base === NavigationBase.DOJO) {
			paths.push(AppRoutesEnum.APP, VersionRouteEnum.V1);
			fragments.push(...routesArray);
		} else if (base === NavigationBase.ANGULAR) {
			paths.push(AppRoutesEnum.APP, VersionRouteEnum.V2, ...routesArray);
		} else {
			throw new Error("Base de navigation inconnue");
		}

		const fragmentsString = fragments.join("/");
		const searchParams = new URLSearchParams(queryParams);
		const queryString = searchParams.toString();

		let url = "/" + paths.join("/");

		if (queryString) {
			url += "?" + queryString;
		}

		if (fragmentsString) {
			url += "#" + fragmentsString;
		}
		return url;
	}

	static replaceUrlParams(url: string, params: Record<string, string | number | boolean>): string {
		let updatedUrl = url;

		(Object.keys(params) as Array<keyof typeof params>).forEach((key) => {
			const value = params[key];
			const placeholder = `:${key}`;
			updatedUrl = updatedUrl.replaceAll(placeholder, encodeURIComponent(String(value)));
		});

		return updatedUrl;
	}

	static generateLink(
		base: NavigationBase,
		routes: RoutesByBase<NavigationBase>,
		queryParams: Record<string, string> = {},
		params: Record<string, string | number | boolean> = {},
	): string {
		return LinkUtils.replaceUrlParams(LinkUtils.generateLinkModel(base, routes, queryParams), params);
	}

	static parseLink(link: string): {
		url: string;
		params: Record<string, string | number | boolean>;
	} {
		const url = new URL(link, window.location.origin);
		return {
			url: link.split("?")[0].split("#")[0],
			params:
				link
					.split("?")[1]
					?.split("&")
					.reduce(
						(acc, param) => {
							const [key, value] = param.split("=");
							acc[key] = decodeURIComponent(value);
							return acc;
						},
						{} as Record<string, string | number | boolean>,
					) || {},
		};
	}
}
